/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContactPerson,
  ContactPersonRequestParams,
} from '../models/index';
import {
    ContactPersonFromJSON,
    ContactPersonToJSON,
    ContactPersonRequestParamsFromJSON,
    ContactPersonRequestParamsToJSON,
} from '../models/index';

export interface CreateContactPersonRequest {
    contactPersonRequestParams: ContactPersonRequestParams;
}

export interface DeleteContactPersonByIdRequest {
    contactPersonId: string;
}

export interface UpdateContactPersonRequest {
    contactPersonId: string;
    contactPersonRequestParams: ContactPersonRequestParams;
}

/**
 * 
 */
export class ContactPersonResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for createContactPerson without sending the request
     */
    async createContactPersonRequestOpts(requestParameters: CreateContactPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['contactPersonRequestParams'] == null) {
            throw new runtime.RequiredError(
                'contactPersonRequestParams',
                'Required parameter "contactPersonRequestParams" was null or undefined when calling createContactPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailer/contact-person`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactPersonRequestParamsToJSON(requestParameters['contactPersonRequestParams']),
        };
    }

    /**
     */
    async createContactPersonRaw(requestParameters: CreateContactPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createContactPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createContactPerson(requestParameters: CreateContactPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createContactPersonRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteContactPersonById without sending the request
     */
    async deleteContactPersonByIdRequestOpts(requestParameters: DeleteContactPersonByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['contactPersonId'] == null) {
            throw new runtime.RequiredError(
                'contactPersonId',
                'Required parameter "contactPersonId" was null or undefined when calling deleteContactPersonById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/contact-person/{contactPersonId}`;
        urlPath = urlPath.replace(`{${"contactPersonId"}}`, encodeURIComponent(String(requestParameters['contactPersonId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteContactPersonByIdRaw(requestParameters: DeleteContactPersonByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteContactPersonByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteContactPersonById(requestParameters: DeleteContactPersonByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContactPersonByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getContactPersonsOfCurrentRetailer without sending the request
     */
    async getContactPersonsOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/contact-person`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getContactPersonsOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContactPerson>>> {
        const requestOptions = await this.getContactPersonsOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContactPersonFromJSON));
    }

    /**
     */
    async getContactPersonsOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContactPerson>> {
        const response = await this.getContactPersonsOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateContactPerson without sending the request
     */
    async updateContactPersonRequestOpts(requestParameters: UpdateContactPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['contactPersonId'] == null) {
            throw new runtime.RequiredError(
                'contactPersonId',
                'Required parameter "contactPersonId" was null or undefined when calling updateContactPerson().'
            );
        }

        if (requestParameters['contactPersonRequestParams'] == null) {
            throw new runtime.RequiredError(
                'contactPersonRequestParams',
                'Required parameter "contactPersonRequestParams" was null or undefined when calling updateContactPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailer/contact-person/{contactPersonId}`;
        urlPath = urlPath.replace(`{${"contactPersonId"}}`, encodeURIComponent(String(requestParameters['contactPersonId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ContactPersonRequestParamsToJSON(requestParameters['contactPersonRequestParams']),
        };
    }

    /**
     */
    async updateContactPersonRaw(requestParameters: UpdateContactPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateContactPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateContactPerson(requestParameters: UpdateContactPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateContactPersonRaw(requestParameters, initOverrides);
    }

}
